<h4>Select where you'd like to book.</h4>
<app-company-select-branch (branchSelected)="branchSelected($event)"></app-company-select-branch>